import { render } from "./aijiuchild.vue?vue&type=template&id=57d8f513"
import script from "./aijiuchild.vue?vue&type=script&lang=js"
export * from "./aijiuchild.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__